import 'tdesign-react/esm/style/index.js';
import 'virtual:svg-icons-register';
import './assets/style/index.less';

import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { ManageRoutes, Routes } from '@/router/index';
import store from '@/store';

import { reportInit } from './report/tam';
import { reportInitV2 } from './report/tamv2';
import { BASE_NAME, WEB_ADMIN_HOME } from './router/const';
import { getDomain } from './utils/getApiDomain';

document.documentElement.setAttribute('theme-mode', 'dark');

reportInit(); // RUM
reportInitV2(); // TAMV2


if (!window.location.pathname.startsWith(BASE_NAME)) {
  window.location.href = `${getDomain()}${BASE_NAME}${WEB_ADMIN_HOME}`;
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(<Provider store={store}>
    <Suspense>
      <RouterProvider router={window.location.href.includes('woa.com') ? ManageRoutes : Routes} />
    </Suspense>
  </Provider>);
}
